import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { VideoProps } from '@/components/atoms/video/index';
import { BlockReferenceArray } from '@/components/cms/types/block';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import BlogMetaData from './index';
import { PostTopic } from './PostTags';
import { AuthorStrapiProps } from '../../../components/organisms/author/AuthorStrapi';

export type TopicsStrapiProps = {
  topic: string;
}[];

export interface BlogMetadataStrapiProps {
  image?: ImageSBProps;
  releaseDate: string;
  timeSpentReading?: number;
  newUntil?: string;
  title?: string;
  video?: VideoProps;
  description: RichTextFieldSBProps;
  topics?: BlockReferenceArray<PostTopic>;
  author?: AuthorStrapiProps['blogAuthor'];
}

export function BlogMetadataStrapi({
  block,
}: BlockComponentModel<BlogMetadataStrapiProps>) {
  const now = new Date();
  const newDate = block.newUntil ? new Date(block.newUntil) : now;

  return (
    <BlogMetaData
      description={
        block?.description ? (
          <RichTextFieldSB
            block={block.description}
            classNames={{ link: { root: 'text-body-l sm:text-blog-body' } }}
          />
        ) : undefined
      }
      title={block.title}
      releaseDate={block.releaseDate}
      timeSpentReading={block.timeSpentReading}
      isNew={newDate > now}
      video={block?.video?.url ?? undefined}
      topics={
        block.topics?.data?.map((topic) => ({
          topic: topic.attributes.topic,
          slug: topic.attributes.slug,
        })) ?? []
      }
      image={
        <ImageSB
          block={{
            ...block.image,
          }}
          inner={{ classNames: { image: 'rounded-xl h-full w-full' } }}
        />
      }
      author={{
        name: block.author?.data?.attributes.name,
        image: (
          <ImageSB
            block={{
              ...block.author?.data?.attributes.image,
            }}
            inner={{
              classNames: { image: 'rounded-full' },
              width: 36,
              height: 36,
            }}
          />
        ),
      }}
    />
  );
}
